import { LOADING } from "../../../constants/constant";
import {
    GET_REJECTED_BOTS_FOR_CARRIER,
    GET_REJECTED_BOTS_FOR_CARRIER_SUCCESS,
    GET_REJECTED_BOTS_FOR_CARRIER_FAILED,
    GET_REJECTED_BOTS_FOR_CARRIER_RESET,
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function getCarrierRejectedBotsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_REJECTED_BOTS_FOR_CARRIER: {
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;
    }

    case GET_REJECTED_BOTS_FOR_CARRIER_SUCCESS: {
      let userRes = Object.assign({}, state);
      // console.log(
      //   "getCarrierRejectedBotsReducer => Case => Success: while getting Rejected bots list: " +
      //     JSON.stringify(action.data)
      // );
      userRes.status = action.data.statusMessage;
      userRes.statusCode = action.data.statusCode;
      userRes.isLoading = false;
      //   userRes.statusCode = action.data.status;
      userRes.botList = action.data.data;

      return userRes;
    }
    case GET_REJECTED_BOTS_FOR_CARRIER_FAILED: {
      console.error(
        "getCarrierRejectedBotsReducer => Case => Error: while getting Rejected bots list: " +
          JSON.stringify(action.error)
      );
      return Object.assign({}, state, action.error);
    }

    case GET_REJECTED_BOTS_FOR_CARRIER_RESET: {
      return initialState;
    }

    default:
      return state;
  }
}
